import React from 'react';
import PropTypes from 'prop-types';
import {Grid} from 'semantic-ui-react';

const TournamentTableColumns = ({columns, data, onClick}) => (<>
    <Grid.Column data-id={data.id} onClick={onClick} width={columns?.tournament_category?.width}>
        {data.tournament?.tournament_category?.name}
    </Grid.Column>
    <Grid.Column data-id={data.id} onClick={onClick} width={columns?.tournament?.width}>
        {data.tournament?.name}
    </Grid.Column>
</>);

TournamentTableColumns.propTypes = {
    columns: PropTypes.object.isRequired,
    data: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        tournament: PropTypes.shape({
            tournament_category: PropTypes.shape({name: PropTypes.string}),
            name: PropTypes.string,
        }),
    }).isRequired,
    onClick: PropTypes.oneOfType([PropTypes.func, PropTypes.oneOf([null])]),
};

export default TournamentTableColumns;

